(() => {
  function playVisibleVideos(scope = document) {
    // Find all Shopify <product-media> elements that contain videos
    const mediaElements = scope.querySelectorAll('product-media');

    mediaElements.forEach((mediaEl) => {
      // Listen for the video element to actually be inserted
      const video = mediaEl.querySelector('video');
      if (!video) {
        // Observe for lazy-loaded video
        const observer = new MutationObserver(() => {
          const loadedVideo = mediaEl.querySelector('video');
          if (loadedVideo) {
            observer.disconnect();
            handleVideo(loadedVideo);
          }
        });
        observer.observe(mediaEl, { childList: true, subtree: true });
      } else {
        handleVideo(video);
      }
    });
  }

  function handleVideo(video) {
    if (!video) return;

    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');

    const tryPlay = () => {
      if (video.paused) {
        video.play().catch(() => {});
      }
    };

    // Autoplay when visible
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tryPlay();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    io.observe(video);
  }

  document.addEventListener('DOMContentLoaded', () => playVisibleVideos());
  document.addEventListener('shopify:section:load', (e) => playVisibleVideos(e.target));
  document.addEventListener('page:loaded', () => playVisibleVideos());
})();